export default __webpack_public_path__ + "static/warning-messages-body-do-c4c84db2d8048b7c5871a1cd2594a0563c8e82bfe45b0d6a8c6b2278835b91ed.png";